<template>
  <div class="transaction">
    <div class="main_box">
      <div class="left_content">
        <ContractMarket></ContractMarket>
      </div>
      <div class="right_content">
        <div class="left_chart">
          <div class="left_chart_top">
            <KLineChart></KLineChart>
          </div>
          <div class="left_chart_bottom">
            <TradingOperation></TradingOperation>
          </div>
        </div>
        <div class="right_realTime">
          <TimeTrading></TimeTrading>
        </div>
      </div>
    </div>
    <div v-if="isSignIn" class="main_bottom">
      <EntrustDetail
        :reverseCurrentMore="true"
        :reverseHistoryMore="true"
      ></EntrustDetail>
    </div>
  </div>
</template>
<script>
import ContractMarket from './components/ContractMarket'
import KLineChart from './components/KLineChart'
import TimeTrading from './components/TimeTrading'
import TradingOperation from './components/TradingOperation'
import EntrustDetail from './components/EntrustDetail'
import { mapGetters } from 'vuex'

export default {
  name: 'Transaction',
  components: {
    ContractMarket,
    KLineChart,
    TimeTrading,
    TradingOperation,
    EntrustDetail,
  },
  computed: {
    ...mapGetters(['isSignIn']),
  },
}
</script>
<style lang="less" scoped>
.transaction {
  min-height: 100%;
  min-width: 1310px;
  // padding-bottom: 21px;
  background: #000;
  overflow: hidden;
  .main_box {
    margin: 10px 0;
    height: 864px;
    display: flex;
    flex-direction: row;
    .left_content {
      margin-right: 10px;
    }
    .right_content {
      display: flex;
      flex-direction: row;
      flex-grow: 1;
      .left_chart {
        flex-grow: 1;
        margin-right: 10px;
        display: flex;
        flex-direction: column;
        .left_chart_bottom {
          flex: 1;
          margin-top: 10px;
          background: @titleBgColor1;
        }
      }
    }
  }
}
</style>
